import { Component, OnInit }       from '@angular/core';
import { ActivatedRoute,Router,Params }  from '@angular/router';
import { Location }        from '@angular/common';


import { PatientService } from '../../services/patients/patient.service';
import { Patient } from '../../classes/patient';


//import { PatientService } from './jquery.json';


import { UserDetailComponent } from '../../users/detail/user-detail.component';

@Component({
  moduleId: module.id,
  selector: 'auth-detail',
  templateUrl: 'patient-auth-detail.component.html',
  styleUrls: [ '../../users/detail/user-detail.component.css' ]
})

export class PatientAuthDetailComponent implements OnInit{


  loading:boolean=true
  loadingInfo:boolean=true
  patient:Patient;
  tbl:any;
  info:string

  //La tabla con los datos del Json se inserta en el body. Si 
  //no la borro nunca va a quedar en el body en todas las paginas
  //entonces me subscribo al "route" para chequear cuando cambio de ruta
  //Para controlar que la borre solo cuando exista y solo una vez, 
  //uso estas dos variables
  remove:boolean=false;
  timesDeleted:number=0;

  constructor(protected patientService: PatientService,
              protected route: ActivatedRoute,
              protected router: Router,
              protected location: Location) {
                  
              }

  ngOnInit(): void {

    //Explicado arriba, sobre los atributos remove y timesDeleted
    this.router.events.subscribe((event) => {
    if (this.remove && this.timesDeleted==0) {
        console.log(this.timesDeleted)
        try{
          document.body.removeChild(this.tbl);
        }
        catch(e){
          console.log(e)
        }
        this.timesDeleted+=1;        

      } 
});

    this.route.params
      .switchMap((params: Params) => this.patientService.getOne(params['id'])
      )
      .subscribe((patient) => {

        this.patient = patient;
        this.loading=false
        this.getInfo();
        this.remove=true;
      });
  }
    



getInfo(){
    let authUser:string = this.patient.auth0_user;
    if (authUser==undefined){
      alert("El paciente no es de prevencion")
      this.location.back();
      return;
    }
    let auth = authUser.split("|")

    let id = auth[auth.length-2] + "|" + auth[auth.length-1]

    this.patientService.getInfo(id)
      .then(info => this.info = info)
      .then(() => {

      let tbl = prettyPrint(this.info, {maxDepth: 5});
       this.tbl=tbl
        if(this.tbl)
          document.body.insertBefore( this.tbl, document.body.firstChild );
        this.loadingInfo=false
      })
  }

  goBack(){
    document.body.removeChild(this.tbl)
    this.remove=false
    this.location.back();
  }

}


// WEBPACK FOOTER //
// ./src/app/patients/detail/patient-auth-detail.component.ts